import {
  updateIssueTypeAction,
  removeIssueAttributeMappingAction,
  updatePendingIssueTypeAction,
  showIssueTypeUpdatedNotificationAction,
  setSelectedIssueTypeMappingRequiredAction
} from '../../../app/actions';
import {
  getIssueTypeForEdit,
  getIssueTypeById,
  getIssueTypeNames,
  getIssueSubTypeNames,
  getIssueTypeDisplayAttributeDefinitions,
  getInheritedIssueTypeAttributeDefinitionIds,
  isUpdatingIssueTypesAdmin,
  isIssueTypesAdminEditModalOpen,
  isUpdatingIssueAttributesMappings,
  getIssueTypeDisplayAttributeMappings,
  isUpdatingRequiredFields
} from '../../../app/selectors';
import {connect} from '../../../app/connect';
import IssueTypeEditModal from './IssueTypeEditModal';
import {serverUpdateRequiredFields} from '../../../app/thunk/requiredfields-thunk';
import featureFlags from '../../../utils/featureFlags';
import {FEATURE_FLAGS} from '../../../constants/featureFlags';

const mapStateToProps = state => {
  const issueTypeForEdit = getIssueTypeForEdit(state);
  const issueTypeForEditParent =
    issueTypeForEdit && issueTypeForEdit.parentId ? getIssueTypeById(state, issueTypeForEdit.parentId) : null;
  let issueTypeNames;
  let issueTypeAttributeMappings = [];
  let issueAttributes = [];
  let inheritedIssueAttributes = [];
  if (issueTypeForEdit) {
    issueTypeNames = issueTypeForEditParent
      ? getIssueSubTypeNames(state, issueTypeForEditParent.childrenIds)
      : getIssueTypeNames(state).concat(getIssueSubTypeNames(state, issueTypeForEdit.childrenIds));
    issueTypeNames = issueTypeNames.filter(
      issueTypeName => issueTypeName.toLowerCase() !== issueTypeForEdit.title.toLowerCase()
    );
    issueAttributes = getIssueTypeDisplayAttributeDefinitions(state);
    issueTypeAttributeMappings = getIssueTypeDisplayAttributeMappings(state);
    inheritedIssueAttributes = getInheritedIssueTypeAttributeDefinitionIds(state);
  }
  return {
    issueTypeForEdit,
    issueTypeForEditParent,
    issueTypeNames,
    saveInProgress:
      isUpdatingIssueTypesAdmin(state) || isUpdatingIssueAttributesMappings(state) || isUpdatingRequiredFields(state),
    issueAttributes,
    inheritedIssueAttributes,
    isOpen: isIssueTypesAdminEditModalOpen(state),
    issueTypeAttributeMappings,
    ffShowDisableTemplatesModal: featureFlags.get(FEATURE_FLAGS.SHOW_DISABLE_TEMPLATES_MODAL)
  };
};

const mapDispatchToProps = {
  updateIssueTypeAction,
  serverUpdateRequiredFields,
  updatePendingIssueTypeAction,
  removeIssueAttributeMappingAction,
  showIssueTypeUpdatedNotificationAction,
  setSelectedIssueTypeMappingRequiredAction
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssueTypeEditModal);
